import React from 'react';
import styled from 'styled-components';

export default styled(({ children, last, ...rest }) => <div {...rest} children={children} />)`
  height: auto;
  min-height: ${({ last }) => (!last ? '3rem' : 'auto')};
`;
